import { GridElementContent } from './GridElementContent';
import {
    defaultGridElementResource,
    GridElementMutationResourceSchema,
    GridElementResource,
    useGridElementActions,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementResource';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { creationDialogOnSuccess } from '../../../util/utilFunctions';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import React from 'react';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const GridElementCreationDialog= ({ onClose, parentId, projectId, projectVersionId, autoGeneratedProps, onCreated }: {
    onClose: () => void;
    parentId: string;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    autoGeneratedProps?: GridElementResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const gridElementActions = useGridElementActions();
    const addGridElement = gridElementActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: GridElementMutationResourceSchema,
        defaultValues: {
            ...defaultGridElementResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addGridElement.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                },
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Grid Element'}
            resourceType={ResourceType.GRID_ELEMENT}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <GridElementContent projectId={projectId} projectVersionId={projectVersionId} form={form}
                                    formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};